module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-container"
  }, [_c('keep-alive', {
    attrs: {
      "include": "Index,ScIndex,meIndex,Agreement,AnswerList,MeAskDetail,teacherList"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.isShowFooter) ? _c('ComFooter') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.tip.isShow) ? _c('myAlertTip', {
    attrs: {
      "text": _vm.tip.text,
      "time": _vm.tip.time
    },
    on: {
      "close-tip": function($event) {
        _vm.tip.isShow = !_vm.tip.isShow
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [_c('LoadingModel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.isShow),
      expression: "loading.isShow"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.loading.text))])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(!_vm.isLogin && _vm.isDisplayLoginPop && !_vm.isApp && !_vm.isMiniProgram) ? _c('newRegisterV2', {
    attrs: {
      "obj": _vm.obj
    },
    on: {
      "loginSuc": _vm.bindUserOrder,
      "hasConpon": _vm.coupon
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isLogin && _vm.isDisplayCouponPop && _vm.isShowFooter) ? _c('newUserPopV2') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.batchObj.isShow && _vm.isBirthdayType != 'birth') ? _c('newUserPopLink', {
    attrs: {
      "newUserObj": _vm.batchObj
    },
    on: {
      "close": _vm.newUserCloseLink
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isFrame) ? _c('FrameCom', {
    attrs: {
      "obj": _vm.frameObj
    },
    on: {
      "close": _vm.closeFrame
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.batchObj.isShow && _vm.isBirthdayType == 'birth') ? _c('birthdayComponent', {
    attrs: {
      "birthdayObj": _vm.batchObj
    },
    on: {
      "close": _vm.newUserCloseLink
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.freeListenHowtoPop) ? _c('section', {
    staticClass: "how-do-pop",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.howdoPopClick($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./image/free_listen_howdo.png"),
      "alt": ""
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b6fb2c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6fb2c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/app.vue
// module id = 417
// module chunks = 32